module.exports = __webpack_public_path__ + "img/icon_home.6d90622.webp";